import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { DateTime } from 'luxon';
import { examDayListFilter } from '../../store/filterStore.js';
import './exd-timebar-button.js';
import './exd-year-button.js';

@customElement('exd-filter-timebar')
export class ExdFilterTimebar extends ChemistryLitElement {
  @state() private readonly _filter = new RXController(this, examDayListFilter);

  mapFilterMonthsToStringMonths() {
    const filterMonths = this._filter.value?.months;
    return new Set(filterMonths ? filterMonths.map(filterMonthInt => this.months[filterMonthInt] as string) : []);
  }

  private readonly months = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];

  private handleMonthClick(month: number, e: PointerEvent) {
    if (e.shiftKey) {
      this.onShiftClick(month);
    } else {
      this.onDefaultClick(month);
    }

    examDayListFilter.next(this._filter.value);
  }

  // Allows you to select a range of months. A bit wonky right now..
  private onShiftClick(month: number) {
    if (this._filter.value.months?.includes(month)) {
      this._filter.value.months = [];
    } else if (this._filter.value.months?.length) {
      const myIndex = month;
      const lastSelected = this._filter.value.months[this._filter.value.months.length - 1];

      const minIndex = Math.min(myIndex, lastSelected);
      const maxIndex = Math.max(myIndex, lastSelected);

      // Create an array from the range between minIndex and maxIndex, then iterates through the strings from the this.months table
      const newMonths = Array.from({ length: maxIndex - minIndex + 1 }, (v, k) => [k + minIndex]) as [];
      this._filter.value.months = newMonths;
    } else {
      if (!this._filter.value.months) this._filter.value.months = [];
      this._filter.value.months.push(month);
    }
  }

  private onDefaultClick(month: number) {
    if (this._filter.value.months?.includes(month)) {
      // remove entry from array if already exists
      const idx = this._filter.value.months.indexOf(month);
      if (idx > -1) this._filter.value.months.splice(idx, 1);
      // this.selectedValues.value.delete(month);
    } else {
      // else, add to array
      if (!this._filter.value.months) this._filter.value.months = [];
      this._filter.value.months.push(month);
      // this.selectedValues.value.add(month);
    }
  }

  getTimebarBtnTone(month: number) {
    if (!this._filter.value.months?.length) return '';

    return this._filter.value.months.includes(month) ? '' : 'subtle';
  }

  setFilterYear(year: number) {
    this._filter.value.year = year;
    this._filter.next(this._filter.value);
  }

  override render() {
    return html`
      <x-flex space="sm">
        <x-flex horizontal center crossaxis-center w100>
          <x-h3> ${this._filter.value.year || DateTime.now().year} </x-h3>
        </x-flex>

        <x-flex horizontal space="sm" crossaxis-center w100>
          <exd-year-button @click=${() => this.setFilterYear(this._filter.value.year - 1)}>
            <x-icon>chevron_left</x-icon>
            <x-text>${this._filter.value.year - 1}</x-text>
          </exd-year-button>

          ${repeat(
            this.months,
            month => month,
            (month, i) =>
              html`<exd-timebar-button tone=${this.getTimebarBtnTone(i)} @click=${e => this.handleMonthClick(i, e)}>
                ${month}
              </exd-timebar-button>`,
          )}

          <exd-year-button @click=${() => this.setFilterYear(this._filter.value.year + 1)}>
            <x-text>${this._filter.value.year + 1}</x-text>
            <x-icon ${css({ fontSize: '20px' })}>chevron_right</x-icon>
          </exd-year-button>
        </x-flex>
      </x-flex>
    `;
  }
}
